(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDeleteController',LicencesDeleteController);

    LicencesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Licences'];

    function LicencesDeleteController($uibModalInstance, entity, Licences) {
        var vm = this;
        vm.licences = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Licences.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
